// export const BASE_URL = "http://localhost:3000/api";
// export const CDN_BASE_URL = "http://localhost:3000/";

export const BASE_URL = "https://api.filetrust.io/api";
export const CDN_BASE_URL = "https://api.filetrust.io/";
export const projectId = "c9a3579c45c6c0a61c076af18f7f58a9";
export const X_clientId = "WG5wRldFYkJnQ2pFekF5RWNWQ286MTpjaQ";
export const YOUTUBE_CHANNEL = "https://www.youtube.com/@FileTrust"
// export const CDN_BASE_URL = "http://localhost:3001/";
// export const BASE_URL = "http://localhost:3001/api";
